import { POPaymentTerm } from '@page-components/PaymentTerm';
import { CommonUtility } from '@utility/common';
import { type JSX, useEffect, useMemo, useState } from 'react';
import { StyledButton } from '@elements/Button';
import type {
  Control,
  FieldErrors,
  UseFormSetValue,
  UseFormGetValues,
} from 'react-hook-form';
import type { IDropdownOption } from '@elements/Dropdown';

interface ITradeTerm {
  value: string;
  text: string;
  content?: JSX.Element;
}

interface IWatchFields {
  down_payment?: number | string;
  upon_shipment?: number | string;
  price_term?: string;
}

interface ICreateTradeTermsFormProps {
  control: Control;
  errors: FieldErrors<any>;
  tradeTermLoading?: boolean;
  tradeTerms?: IDropdownOption[];
  discountRule?: any;
  watchFields: IWatchFields;
  moveToNextStep?: () => void;
  setValue: UseFormSetValue<any>;
  getValues: UseFormGetValues<any>;
}

export function CreateTradeTermsForm({
  control,
  errors,
  tradeTermLoading,
  tradeTerms,
  discountRule,
  watchFields,
  moveToNextStep,
  setValue,
  getValues,
}: ICreateTradeTermsFormProps) {
  const [terms, setTerms] = useState<IDropdownOption[]>([]);

  const completed = useMemo(() => {
    const { down_payment, upon_shipment, price_term } = watchFields;

    if (
      !CommonUtility.isNotEmpty(down_payment) ||
      !CommonUtility.isNotEmpty(upon_shipment) ||
      !price_term
    )
      return false;

    return true;
  }, [watchFields]);

  useEffect(() => {
    const temp: IDropdownOption[] = [];
    tradeTerms?.forEach(element => {
      if (
        element.value === 'NET 45' ||
        element.value === 'NET 30' ||
        element.value === 'NET 60'
      ) {
        temp.push({
          ...element,
          content: (
            <div>
              <span className="sk:text-sm">{element.text}</span>
              <span className="sk:block sk:text-[13px] sk:opacity-50">
                Due {element.text.slice(3, 7)} days after completion
              </span>
            </div>
          ),
        });
      } else {
        temp.push(element);
      }
    });
    setTerms(temp);
  }, [tradeTerms]);

  return (
    <div className="sk:px-3.5! sk:pb-3.5!">
      <POPaymentTerm
        control={control}
        errors={errors}
        tradeTerms={terms}
        tradeTermLoading={tradeTermLoading}
        discountRule={discountRule}
        setValue={setValue}
        getValues={getValues}
        defaultValue={undefined}
      />
      <div className="sk:flex sk:justify-end">
        <StyledButton
          type="button"
          className="no-break"
          onClick={() => moveToNextStep?.()}
          disabled={!completed}
        >
          Enter Details
        </StyledButton>
      </div>
    </div>
  );
}
